module.exports = __webpack_public_path__ + "static/media/integral.2256601c.svg";